import _ from 'underscore';
import { getScreenBreakpoints, getScreenWidth } from './screen';

let elementUnderCursor = null;
let closePanelTimeoutID = null;
const screen_id_desktop_start = 'xl';

const initListHover = ( link, panels_container ) => {
	panels_container.classList.remove( 'expanded', 'hovered' );
	panels_container.querySelectorAll( '.nav-panels-container .panel-content > div' ).forEach( el => {
		el.classList.remove( 'hover-active', 'active' );
	});

	if ( getScreenWidth() < getScreenBreakpoints( screen_id_desktop_start ) ) {
		return;
	}

	const li = link.closest( 'li.wp-block-navigation-item.has-child' );
	if ( li !== null ) {		
		li.addEventListener( 'mouseenter', ( ev ) => {
			const topnav_container = document.querySelector( '.top-navs-container' );
			if ( ( topnav_container !== null ) && topnav_container.classList.contains( 'search-form-active' ) ) {
				return;
			}

			if ( panels_container.classList.contains( 'expanded' ) ) {
				return;
			}
			if ( ! panels_container.classList.contains( 'hovered' ) ) {
				panels_container.classList.add( 'hovered' );
			}
			const dest = li.id.replace( 'trigger', 'block' );
			const dest_panel = panels_container.querySelector( `#${dest}` );
			if ( dest_panel !== null ) {
				panels_container.querySelectorAll( '.nav-panels-container .panel-content > div' ).forEach( el => {
					el.classList.remove( 'hover-active', 'active' );
				});
				dest_panel.classList.add( 'hover-active' );
			}
		});
	}
};

const setupClosePanelTimeout = ( panels_container ) => {
	closePanelTimeoutID = setTimeout( () => {
		if ( ( elementUnderCursor.closest( '.cga-2026-top-navigations' ) !== null ) || ( elementUnderCursor.closest( '.main-nav-panels-container' ) !== null ) ) {
			setupClosePanelTimeout( panels_container );
		} else {
			panels_container.classList.remove( 'hovered' );
		}
	}, 1000 );
};

const initListParentHover = ( container, panels_container ) => {
	if ( getScreenWidth() < getScreenBreakpoints( screen_id_desktop_start ) ) {
		return;
	}

	if ( panels_container.classList.contains( 'expanded' ) ) {
		return;
	}

	document.addEventListener( 'mousemove', ( ev ) => {
		elementUnderCursor = ev.target;
	});

	container.addEventListener( 'mouseenter', () => {
		const topnav_container = document.querySelector( '.top-navs-container' );
		if ( ( topnav_container !== null ) && topnav_container.classList.contains( 'search-form-active' ) ) {
			return;
		}
		setupClosePanelTimeout( panels_container );
		panels_container.classList.add( 'hovered' );
	});
};

const initClickEvent = ( link, nav_items, panels_container ) => {
	if ( getScreenWidth() <= getScreenBreakpoints( screen_id_desktop_start ) ) {
		return;
	}

	if ( 'phOnClick' in link.dataset ) {
		return;
	}

	link.setAttribute( 'data-ph-on-click', 'true' );

	initListHover( link, panels_container );

	link.addEventListener( 'click', ev => {
		ev.preventDefault();
		panels_container.classList.remove( 'hovered' );
		nav_items.forEach( a_li => {
			a_li.closest( 'li' ).classList.remove( 'active' );
		});
		const li = ev.target.closest( 'li.wp-block-navigation-item' );
		if ( li !== null ) {
			const dest = li.id.replace( 'trigger', 'block' );
			const dest_panel = panels_container.querySelector( `#${dest}` );
			if ( dest_panel !== null ) {
				panels_container.classList.remove( 'expanded' );
				if ( dest_panel.classList.contains( 'active' ) ) {
					dest_panel.classList.remove( 'active' );
				} else {
					li.classList.add( 'active' );
					panels_container.querySelectorAll( '.nav-panels-container .panel-content > div' ).forEach( el => {
						el.classList.remove( 'active', 'hover-active' );
					});
					dest_panel.classList.add( 'active' );
					panels_container.classList.add( 'expanded' );
				}
			}
		}
	});

};

const initDocClick = ( nav_items, panels_container ) => {
	document.addEventListener( 'click', ev => {
		if ( ev.target.closest( '.cga-2026-header' ) === null ) {
			// Clicked outside header
			panels_container.classList.remove( 'expanded' );
			panels_container.querySelectorAll( '.nav-panels-container .panel-content > div' ).forEach( el => {
				el.classList.remove( 'active', 'hover-active' );
			});
			nav_items.forEach( a_li => {
				a_li.closest( 'li' ).classList.remove( 'active' );
			});
		}
	});
};

const initCloseBtn = ( nav_items, panels_container ) => {
	const closeBtn = panels_container.querySelector( '.panel-header .close-navigation-panel-button' );
	if ( closeBtn !== null ) {
		closeBtn.addEventListener( 'click', ev => {
			ev.preventDefault();
			panels_container.classList.remove( 'expanded', 'hovered' );
			panels_container.querySelectorAll( '.nav-panels-container .panel-content > div' ).forEach( el => {
				el.classList.remove( 'hover-active', 'active' );
			});
			nav_items.forEach( a_li => {
				a_li.closest( 'li' ).classList.remove( 'active' );
			});
		});
	}
};

const initNavPanelContainer = ( nav_items, container, panels_container ) => {
	initCloseBtn( nav_items, panels_container );
};

const initSearchTrigger = ( header_container, nav_items, panels_container ) => {
	const topnav_container = header_container.querySelector( '.top-navs-container' );
	if ( topnav_container === null ) {
		return;
	}
	const trigger = topnav_container.querySelector( '.cga-search-trigger' );
	if ( trigger === null ) {
		return;
	}
	trigger.addEventListener( 'click', ev => {
		ev.preventDefault();
		panels_container.classList.remove( 'expanded', 'hovered' );
		nav_items.forEach( a_li => {
			a_li.closest( 'li' ).classList.remove( 'active' );
		});
		header_container.classList.add( 'search-form-active' );
	});

	const search_form_closer = header_container.querySelector( '.cga-search-form-closer' );
	if ( search_form_closer !== null ) {
		search_form_closer.addEventListener( 'click', ev => {
			ev.preventDefault();
			header_container.classList.remove( 'search-form-active' );
		});
	}
};

const initHeaderMobileNavigations = () => {
	if ( getScreenWidth() > getScreenBreakpoints( screen_id_desktop_start ) ) {
		return;
	}

	const header = document.querySelector( 'header.wp-block-template-part' );
	if ( !header ) {
		return;
	}

	const navBlocks = header.querySelectorAll( '.wp-block-navigation' );
	if ( navBlocks.length < 1 ) {
		return;
	}

	navBlocks.forEach( nav => {
		const responsiveContainer = nav.querySelector( '.wp-block-navigation__responsive-container' );
		if ( !responsiveContainer ) {
			return;
		}
		
		const observer = new MutationObserver( ( mutations ) => {
			mutations.forEach( mutation => {
				if ( mutation.type === 'attributes' && mutation.attributeName === 'class' ) {
					const isOpen = responsiveContainer.classList.contains( 'is-menu-open' );
					if ( isOpen ) {
						header.classList.add( 'navigation-menu-opened' );
						document.documentElement.classList.add( 'header-navigation-menu-opened' );
					} else {
						header.classList.remove( 'navigation-menu-opened' );
						document.documentElement.classList.remove( 'header-navigation-menu-opened' );
					}
				}
			});
		});
		
		observer.observe( responsiveContainer, { attributes: true } );

		const submenuToggles = responsiveContainer.querySelectorAll( '.wp-block-navigation-submenu__toggle' );
		if ( submenuToggles.length > 0 ) {
			submenuToggles.forEach( submenuToggle => {
				// Make sure we only add event listener once
				if ( 'wpOn-Click' in submenuToggle.dataset ) {
					submenuToggle.removeAttribute( 'data-wp-on--click' );
					submenuToggle.removeAttribute( 'data-wp-bind--aria-expanded' );
					submenuToggle.setAttribute( 'aria-expanded', "false" );
					submenuToggle.addEventListener( 'click', ( ev ) => {
						ev.preventDefault();
						const isExpanded = submenuToggle.getAttribute( 'aria-expanded' ) === 'true';
						submenuToggle.closest( 'ul' ).querySelectorAll( ':scope > li' ).forEach( el => {
							el.classList.remove( 'menu-expanded' );
							el.querySelector( '.wp-block-navigation-submenu__toggle' ).setAttribute( 'aria-expanded', 'false' );
						});
						submenuToggle.setAttribute( 'aria-expanded', String( !isExpanded ) );
						if ( isExpanded ) {
							submenuToggle.closest( 'li' ).classList.remove( 'menu-expanded' );
						} else {
							submenuToggle.closest( 'li' ).classList.add( 'menu-expanded' );
						}
					});
				}
			});
		}
	});
};

const moveSiteComponent = ( header_container, top_nav_container ) => {
	const siteComponent = header_container.querySelector( '.site-component.component-name-main-utility-navigation' );
	if ( siteComponent !== null ) {
		const mobileContainer = top_nav_container.querySelector( '.wp-block-navigation__responsive-container .wp-block-navigation__responsive-dialog .wp-block-navigation__responsive-container-content' );
		if ( mobileContainer !== null ) {
			if ( getScreenWidth() < getScreenBreakpoints( screen_id_desktop_start ) ) {
				if ( mobileContainer.querySelector( '.site-component.component-name-main-utility-navigation' ) === null ) {
					mobileContainer.appendChild( siteComponent );
				}
			} else {
				if ( mobileContainer.querySelector( '.site-component.component-name-main-utility-navigation' ) !== null ) {
					top_nav_container.after( siteComponent );
				}
			}
		}
	}
};

const initCGATopnavigations = ( header_container ) => {
	initHeaderMobileNavigations();

	const container = header_container.querySelector( 'nav.cga-2026-top-navigations' );
	if ( container === null ) {
		return;
	}

	moveSiteComponent( header_container, container );

	const nav_items = container.querySelectorAll( 'li.wp-block-navigation-item.has-child.wp-block-navigation-submenu > button.wp-block-navigation-submenu__toggle' );
	if ( nav_items.length < 1 ) {
		return;
	}

	const panels_container = header_container.querySelector( '.main-nav-panels-container' );
	if ( panels_container === null ) {
		return;
	}

	nav_items.forEach( el => {
		initClickEvent( el, nav_items, panels_container );
	})

	initListParentHover( container, panels_container );
	initNavPanelContainer( nav_items, container, panels_container );
	initDocClick( nav_items, panels_container );
	initSearchTrigger( header_container, nav_items, panels_container );
};

const initCGA2026Header = () => {
	const header_container = document.querySelector( '.cga-2026-header' );
	if ( header_container === null ) {
		return;
	}

	initCGATopnavigations( header_container );
};

const initCGA2026Navigations = () => {
	initCGA2026Header();
};

export default initCGA2026Navigations;